import { Toast } from "@/molecules";
import { useState } from "react";
import { useMedia } from "react-use";

import * as Portal from "@radix-ui/react-portal";
import { AnimatePresence } from "framer-motion";

type Props = {
  title: string;
  description?: string;
};

const SLIDE_ANIMATION_DISTANCE = 50;

export default function GlobalErrorPopout({ title, description }: Props) {
  const [show, setShow] = useState(true);
  const isMobile = useMedia("(max-width: 640px)");

  return (
    <AnimatePresence>
      {show && (
        <Portal.Root>
          <div className="pointer-events-none fixed inset-0 z-[70] flex w-full items-end px-4 py-6 sm:p-6">
            <div className="pointer-events-none flex w-full flex-col items-center space-y-4 sm:items-end">
              <Toast
                title={title}
                description={description}
                type="error"
                initial={{
                  x: isMobile ? 0 : SLIDE_ANIMATION_DISTANCE,
                  y: isMobile ? SLIDE_ANIMATION_DISTANCE : 0,
                  opacity: 0,
                }}
                animate={{ x: 0, y: 0, opacity: 1 }}
                exit={{
                  x: isMobile ? 0 : SLIDE_ANIMATION_DISTANCE,
                  y: isMobile ? SLIDE_ANIMATION_DISTANCE : 0,
                  opacity: 0,
                }}
                className="pointer-events-auto"
                onDismiss={() => {
                  setShow(false);
                }}
              />
            </div>
          </div>
        </Portal.Root>
      )}
    </AnimatePresence>
  );
}
